import React from "react";
import { Create, translate } from "react-admin";
import FacilitiesForm from "./FacilitiesForm";

const FacilitiesTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("facilities.facilities")}`}</span>;
};

const Title = translate(FacilitiesTitle);

export const FacilitiesCreate = props => (
  <Create title={<Title />} {...props}>
    <FacilitiesForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/facilities/FacilitiesCreate.js